import React from 'react';
import Icon from '../../../components/AppIcon';

const NotificationItem = ({ notification, onMarkAsRead }) => {
  const getNotificationIcon = (type) => {
    const icons = {
      'info': 'Info',
      'success': 'CheckCircle',
      'warning': 'AlertTriangle',
      'error': 'AlertCircle',
      'message': 'MessageSquare',
      'update': 'RefreshCw'
    };
    return icons?.[type] || 'Bell';
  };

  const getNotificationColor = (type) => {
    const colors = {
      'info': 'bg-primary/10 text-primary',
      'success': 'bg-success/10 text-success',
      'warning': 'bg-warning/10 text-warning',
      'error': 'bg-error/10 text-error',
      'message': 'bg-accent/10 text-accent',
      'update': 'bg-secondary/10 text-secondary'
    };
    return colors?.[type] || 'bg-muted text-muted-foreground';
  };

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const notificationTime = new Date(timestamp);
    const diffInMinutes = Math.floor((now - notificationTime) / (1000 * 60));

    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    if (diffInMinutes < 1440) return `${Math.floor(diffInMinutes / 60)}h ago`;
    return `${Math.floor(diffInMinutes / 1440)}d ago`;
  };

  return (
    <div className={`flex items-start gap-3 p-3 md:p-4 rounded-lg transition-all duration-200 ${
      notification?.isRead ? 'bg-transparent' : 'bg-primary/5 hover:bg-primary/10'
    }`}>
      <div className={`w-8 h-8 md:w-10 md:h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${getNotificationColor(notification?.type)}`}>
        <Icon name={getNotificationIcon(notification?.type)} size={16} className="md:w-5 md:h-5" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-2 mb-1">
          <h4 className="text-xs md:text-sm font-semibold text-foreground line-clamp-2">
            {notification?.title}
          </h4>
          {!notification?.isRead && (
            <div className="w-2 h-2 rounded-full bg-primary flex-shrink-0 mt-1" />
          )}
        </div>
        
        <p className="text-xs text-muted-foreground line-clamp-2 mb-2">
          {notification?.message}
        </p>

        <div className="flex items-center justify-between">
          <span className="text-xs text-muted-foreground">
            {formatTimeAgo(notification?.timestamp)}
          </span>
          {!notification?.isRead && (
            <button
              onClick={() => onMarkAsRead(notification?.id)}
              className="text-xs text-primary hover:underline"
            >
              Mark as read
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationItem;